<div class="card leaderboard-card rounded" [class.widget]="isWidget">
  <div class="nav d-flex align-items-center justify-content-center leaderboard-navigation rounded w-100 align-self-center">
    <fgb-tab
      [tabs]="['leaderboard.v2.monthly' | translate, 'leaderboard.v2.yearly' | translate]"
      [minWidth]="isSmallVersion ? 145 : 163"
      (tabSelectionChange)="onTabChage($event)"
      [isSmallVersion]="isSmallVersion"
    />
  </div>
  <div class="leaderboard-nav" *ngIf="showMonthly; else yearly">
    <owl-carousel-o #owlCarouselRef [options]="customOptions" (translated)="onSlideChanged($event)">
      <ng-template carouselSlide *ngFor="let item of monthlyLeaderboard; let i = index">
        <div class="py-2 leaderboard-date-toggle">
          <h2 class="text-center fw-bold font-size-14 m-0">{{ item.date | date: 'MMMM' }}</h2>
        </div>
        <!-- Loading state -->
        @if (isCarouselReady) {
          <div *ngIf="item.entries.length > 0">
            <div class="mt-4 ranking-list">
              <ng-container *ngTemplateOutlet="leaderboardItemListTemplate; context: { $implicit: item }"> </ng-container>
            </div>
          </div>
          <div *ngIf="item.entries.length === 0">
            <div class="leaderboard-empty-placeholder mt-3">
              <img fgbAnimateSvg src="assets/images/games/leaderboard-no-data.svg" alt="" class="my-4" />
              <p class="fw-bold font-size-14">
                {{ 'leaderboard.v2.monthly.no.entries' | translate }}
              </p>
            </div>
          </div>
        } @else {
          <div class="text-center py-3 mt-3">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      </ng-template>
    </owl-carousel-o>

    @if (isWidget) {
      <div class="leaderboard-button text-center w-100">
        <a class="fw-bold font-size-14" [routerLink]="['/fantasyleaderboard']">{{
          'pick.player.view.full.leaderboard' | translate
        }}</a>
      </div>
    }
  </div>
  <ng-template #yearly>
    <div class="py-3 text-center font-size-14">
      <!-- Loading state -->
      <div *ngIf="loadingYear" class="text-center py-3 mt-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div *ngIf="!loadingYear && yearlyLeaderboards.length > 0">
        <div class="ranking-list">
          <ng-container
            *ngTemplateOutlet="leaderboardItemListTemplate; context: { $implicit: yearlyLeaderboards, topThree, challengers }"
          >
          </ng-container>
        </div>
      </div>
      <div *ngIf="!loadingYear && yearlyLeaderboards.length === 0">
        <div class="leaderboard-empty-placeholder mt-3">
          <img fgbAnimateSvg src="assets/images/games/leaderboard-no-data.svg" alt="" class="my-4" />
          <p class="fw-bold font-size-14">
            {{ 'leaderboard.v2.seasonal.no.entries' | translate }}
          </p>
        </div>
      </div>
    </div>

    @if (isWidget) {
      <div class="leaderboard-button text-center w-100">
        <a class="fw-bold font-size-14" [routerLink]="['/fantasyleaderboard']">{{
          'pick.player.view.full.leaderboard' | translate
        }}</a>
      </div>
    }
  </ng-template>
</div>

<ng-template #leaderboardItemListTemplate let-data let-topThree="topThree" let-challengers="challengers">
  <ng-container *ngFor="let item of data?.topThree || topThree">
    <div
      class="font-size-14 fantasy-row"
      [ngClass]="{ first: item.tier === 'gold', second: item.tier === 'silver', third: item.tier === 'bronze' }"
    >
      <div class="rank-item">
        <div class="rank-number fw-bold">
          @if (item.tier === 'gold') {
            <span class="material-symbols-outlined">crown</span>
          } @else {
            {{ item.Position }}
          }
        </div>
        <div class="rank-name text-capitalize fw-bold" [ngClass]="{ 'short-name': isSmallVersion }">{{ item.FullName }}</div>
        <div class="rank-points">
          {{ item.Points | FortressCurrencyPipe: 'PTS' }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngFor="let item of data?.challengers || challengers">
    <div class="font-size-14 fantasy-row" [ngClass]="{ 'current-user': item.IsCurrentUser }">
      <div class="rank-item">
        <div class="rank-number fw-bold">
          {{ item.Position }}
        </div>
        <div class="rank-name text-capitalize fw-bold" [ngClass]="{ 'short-name': isSmallVersion }">{{ item.FullName }}</div>
        <div class="rank-points">
          {{ item.Points | FortressCurrencyPipe: 'PTS' }}
        </div>
      </div>
    </div>
  </ng-container>
  @if (isWidget && (data?.currentUser || currentUser) && !isUserTopThree) {
    <div class="font-size-14 fantasy-row current-user mt-3">
      <div class="rank-item">
        <div class="rank-number fw-bold">
          {{ data?.currentUser?.Position || currentUser.Position }}
        </div>
        <div class="rank-name text-capitalize fw-bold" [ngClass]="{ 'short-name': isSmallVersion }">
          {{ data?.currentUser?.FullName || currentUser.FullName }}
        </div>
        <div class="rank-points">
          {{ data?.currentUser?.Points || currentUser.Points | FortressCurrencyPipe: 'PTS' }}
        </div>
      </div>
    </div>
  }
</ng-template>
